import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import ServicesSection from "../components/ServiceSection";
import SignUp from "../components/SignUp";
// import Projects from "../components/Projects/Projects";
import "react-toastify/dist/ReactToastify.css";
import Proyectos from "../components/Proyectos/Proyectos";
import InfoSection from "../components/InfoSection";
import { homeObjOne, homeObjThree } from "../components/InfoSection/Data";

const Projectspage = () => {
  const [isOpen, setIsopen] = useState(false);

  const toogle = () => {
    setIsopen(!isOpen);
  };

  const [currentLanguage, setCurrentLanguage] = useState("es");

  const handleLanguageChange = (newLanguage) => {
    setCurrentLanguage(newLanguage);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toogle={toogle} />
      <Navbar
        toogle={toogle}
        isOpen={isOpen}
        currentLanguage={currentLanguage}
        onChangeLanguage={handleLanguageChange}
      />
     
      {/* <Projects /> */}
      <div style={{ marginTop:"80px" }}>
        <Proyectos />
      </div>
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjOne} />
      <ServicesSection />
      <SignUp />
    </>
  );
};

export default Projectspage;
